import update from "immutability-helper";
import { findIndex as _findIndex } from "lodash-es";

import {
  CREATE_HUMAN_COMMENT,
  DELETE_HUMAN_COMMENT,
  REVERT_HUMAN_COMMENT,
  UPDATE_HUMAN_COMMENT,
} from "../actions/humanComments";
import { UPDATE_HUMAN_TAGS } from "../actions/humans";
import { FETCH_UPDATES_SUCCESS, SET_PENDING, SET_SAVED } from "../actions/sync";
import {
  makeHumanTagChecker,
  makeHumanTagNameSlugUpdater,
  makeObjectsSaved,
  setPendingFlag,
  updateFromFetchUpdates,
} from "../utils";

const updateHumanTagsInComments = (comments, humanId, newName) => {
  const checkHasTag = makeHumanTagChecker(humanId);
  const updateSlugs = makeHumanTagNameSlugUpdater(humanId, newName);

  return comments.map((comment) => {
    if (!checkHasTag(comment.text)) return comment;

    return {
      ...comment,
      text: updateSlugs(comment.text),
      modified: true,
    };
  });
};

export default function humanComments(state = [], action) {
  switch (action.type) {
    case CREATE_HUMAN_COMMENT: {
      return [
        ...state,
        {
          id: action.id,
          humanId: action.humanId,
          text: action.text,
          createdAt: new Date().toISOString(),
          modifiedAt: new Date().toISOString(),
          pending: false,
          modified: true,
        },
      ];
    }

    case UPDATE_HUMAN_TAGS: {
      return updateHumanTagsInComments(state, action.humanId, action.newName);
    }

    case FETCH_UPDATES_SUCCESS: {
      return updateFromFetchUpdates(state, action.payload.data.humanComments);
    }

    case UPDATE_HUMAN_COMMENT: {
      const humanCommentIndex = _findIndex(state, { id: action.id });
      if (humanCommentIndex < 0) return state;

      if (action.obj.modified) {
        action.obj.modifiedAt = new Date().toISOString();
      }
      return update(state, { [humanCommentIndex]: { $merge: action.obj } });
    }

    case SET_PENDING: {
      return setPendingFlag(state, action.data.humanComment, action.pending);
    }

    case SET_SAVED: {
      return makeObjectsSaved(state, action.data.humanComment);
    }

    case DELETE_HUMAN_COMMENT: {
      const humanCommentIndex = _findIndex(state, { id: action.id });
      if (humanCommentIndex < 0) return state;

      return update(state, { $splice: [[humanCommentIndex, 1]] });
    }

    case REVERT_HUMAN_COMMENT: {
      const humanCommentIndex = _findIndex(state, { id: action.id });
      if (humanCommentIndex < 0) return state;

      const humanComment = state[humanCommentIndex];
      if (!humanComment.conflict) return state;

      return update(state, {
        [humanCommentIndex]: { $set: humanComment.conflict },
      });
    }

    default:
      return state;
  }
}
